export default "__VITE_ASSET__B5Hiat99__"